(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('pagarmeConnectedControl', {
            templateUrl: 'app/admin/settings/payments/components/pagarme-connected-control/pagarme-connected-control.html',
            bindings: {
                pagarMeAccount: '<',
                pagarmeOptions: '<',
                isCreditCardEnabled: '=',
                isBoletoEnabled: '=',
                hasLoadError: '=',
                onActivateDeactivate: '&',
                onDisconnect: '&',
                onEdit: '&',
                isDisconnectDisabled: '&'
            },
            controller: pagarmeConnectedControlController
        });

    pagarmeConnectedControlController.$inject = ['$translate', 'ModalFactory', 'pagarmeConstants', 'cpfCnpjFilter', 'PagarMeV5Service', 'BankDataService', '$q', 'toastr'];

    function pagarmeConnectedControlController($translate, ModalFactory, pagarmeConstants, cpfCnpjFilter, PagarMeV5Service, BankDataService, $q, toastr) {
        var $ctrl = this;

        $ctrl.recipientTypeLabel = '';
        $ctrl.recipientNameValue = '';
        $ctrl.recipientDocumentValue = '';
        $ctrl.recipientEmailValue = '';
        $ctrl.bankNameLabel = '';
        $ctrl.holderTypeLabel = '';
        $ctrl.bankAccountTypeLabel = '';
        $ctrl.branchNumberModel = {};
        $ctrl.accountNumberModel = {};
        $ctrl.transferIntervalLabel = '';
        $ctrl.transferDayLabel = '';

        var PAYMENT_METHOD_CREDIT_CARD = 'CREDIT_CARD';
        var PAYMENT_METHOD_BOLETO = 'BOLETO';

        var WEEKDAY_LABEL_KEYS = {
            1: 'monday',
            2: 'tuesday',
            3: 'wednesday',
            4: 'thursday',
            5: 'friday'
        };

        var PAYMENT_METHOD_CONFIG = {};
        PAYMENT_METHOD_CONFIG[PAYMENT_METHOD_CREDIT_CARD] = {
            enabledField: 'isCreditCardEnabled',
            deactivateTitleKey: 'settings.store.payments.tabs.pagarMe.sureDeactivateCreditCardTitle',
            deactivateQuestionKey: 'settings.store.payments.tabs.pagarMe.sureDeactivateCreditCardQuestion'
        };
        PAYMENT_METHOD_CONFIG[PAYMENT_METHOD_BOLETO] = {
            enabledField: 'isBoletoEnabled',
            deactivateTitleKey: 'settings.store.payments.tabs.pagarMe.sureDeactivateBoletoTitle',
            deactivateQuestionKey: 'settings.store.payments.tabs.pagarMe.sureDeactivateBoletoQuestion'
        };

        $ctrl.togglePaymentMethod = function (paymentMethod) {
            var config = PAYMENT_METHOD_CONFIG[paymentMethod];
            var isEnabled = $ctrl[config.enabledField];

            function activateDeactivate() {
                var dto = {
                    isEnabled: isEnabled,
                    isCreditCardEnabled: $ctrl.isCreditCardEnabled,
                    isBoletoEnabled: $ctrl.isBoletoEnabled
                };
                $ctrl.onActivateDeactivate({ id: $ctrl.pagarMeAccount.id, paymentCondition: paymentMethod, dto: dto });
            }

            if (!isEnabled) {
                ModalFactory.openWarningModal(null,
                    $translate.instant(config.deactivateTitleKey),
                    $translate.instant(config.deactivateQuestionKey),
                    null,
                    $translate.instant('settings.store.payments.tabs.pagarMe.yes'),
                    $translate.instant('settings.store.payments.tabs.pagarMe.no'),
                    activateDeactivate,
                    function () {
                        $ctrl[config.enabledField] = true;
                    }
                );
            } else {
                activateDeactivate();
            }
        };

        $ctrl.disconnect = function () {
            $ctrl.onDisconnect();
        };

        $ctrl.edit = function () {
            $ctrl.onEdit();
        };

        $ctrl.isPagarmeTokenConnected = function () {
            var apiVersion = $ctrl.pagarMeAccount && $ctrl.pagarMeAccount.apiVersion;
            var isTokenApiVersion = apiVersion === pagarmeConstants.API_VERSION.V4 || apiVersion === pagarmeConstants.API_VERSION.V5;
            return isTokenApiVersion && !!($ctrl.pagarMeAccount && $ctrl.pagarMeAccount.accountId);
        };

        $ctrl.isPagarmeShowkasePayConnected = function () {
            var apiVersion = $ctrl.pagarMeAccount && $ctrl.pagarMeAccount.apiVersion;
            var isShowkasePayApiVersion = apiVersion === pagarmeConstants.API_VERSION.SHOWKASE_PAY || apiVersion === pagarmeConstants.API_VERSION.SHOWKASE_PAY_V5;
            return isShowkasePayApiVersion && !!($ctrl.pagarMeAccount && $ctrl.pagarMeAccount.recipientId);
        };

        $ctrl.isPagarMeAnyConnected = function () {
            return $ctrl.isPagarmeTokenConnected() || $ctrl.isPagarmeShowkasePayConnected();
        };

        $ctrl.isTokenDataInvalid = function () {
            var apiVersion = $ctrl.pagarMeAccount && $ctrl.pagarMeAccount.apiVersion;
            var isTokenApiVersion = apiVersion === pagarmeConstants.API_VERSION.V4 || apiVersion === pagarmeConstants.API_VERSION.V5;
            if (!isTokenApiVersion) {
                return false;
            }
            return !($ctrl.pagarMeAccount.accountId && $ctrl.pagarMeAccount.installId && $ctrl.pagarMeAccount.merchantId);
        };

        $ctrl.isShowkasePayDataInvalid = function () {
            var apiVersion = $ctrl.pagarMeAccount && $ctrl.pagarMeAccount.apiVersion;
            var isShowkasePayApiVersion = apiVersion === pagarmeConstants.API_VERSION.SHOWKASE_PAY || apiVersion === pagarmeConstants.API_VERSION.SHOWKASE_PAY_V5;
            if (!isShowkasePayApiVersion) {
                return false;
            }
            var registerInformation = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.registerInformation;
            var hasRecipientName = registerInformation && (registerInformation.name || registerInformation.companyName);
            var hasRecipientDocument = registerInformation && registerInformation.documentNumber;
            return !($ctrl.pagarMeAccount.recipientId && registerInformation && hasRecipientName && hasRecipientDocument);
        };

        $ctrl.computeHasLoadError = function () {
            if (!$ctrl.pagarMeAccount || !$ctrl.pagarMeAccount.apiVersion) {
                return false;
            }
            return $ctrl.isTokenDataInvalid() || $ctrl.isShowkasePayDataInvalid();
        };

        $ctrl.isCorporateRecipient = function () {
            var registerInformation = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.registerInformation;
            return !!(registerInformation && registerInformation.type === pagarmeConstants.RECIPIENT_TYPE.CORPORATION);
        };

        $ctrl.getRecipientTypeLabel = function () {
            var key = $ctrl.isCorporateRecipient() ?
                'settings.store.payments.tabs.pagarMe.recipientForm.corporation' :
                'settings.store.payments.tabs.pagarMe.recipientForm.individual';
            return $translate.instant(key);
        };

        $ctrl.getRecipientName = function () {
            var registerInformation = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.registerInformation;
            if (!registerInformation) {
                return '';
            }
            return $ctrl.isCorporateRecipient() ? registerInformation.companyName : registerInformation.name;
        };

        $ctrl.getRecipientDocument = function () {
            var registerInformation = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.registerInformation;
            var documentNumber = registerInformation && registerInformation.documentNumber;
            return documentNumber ? cpfCnpjFilter(documentNumber) : '';
        };

        $ctrl.getRecipientEmail = function () {
            var registerInformation = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.registerInformation;
            return (registerInformation && registerInformation.email) || '';
        };

        $ctrl.getHolderTypeLabel = function () {
            var bankAccount = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.bankAccount;
            var holderType = bankAccount && bankAccount.holderType;
            if (!holderType) {
                return '';
            }
            var key = holderType === pagarmeConstants.BANK_ACCOUNT_TYPE.COMPANY ?
                'settings.store.payments.tabs.pagarMe.recipientForm.corporation' :
                'settings.store.payments.tabs.pagarMe.recipientForm.individual';
            return $translate.instant(key);
        };

        $ctrl.getBankAccountTypeLabel = function () {
            var bankAccount = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.bankAccount;
            var accountType = bankAccount && bankAccount.type;
            if (!accountType) {
                return '';
            }
            var key = accountType === pagarmeConstants.BANK_ACCOUNT_TYPE_OPTIONS.CONTA_POUPANCA ?
                'settings.store.payments.tabs.pagarMe.recipientForm.contaPoupanca' :
                'settings.store.payments.tabs.pagarMe.recipientForm.contaCorrente';
            return $translate.instant(key);
        };

        $ctrl.getBranchNumberModel = function () {
            var bankAccount = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.bankAccount;
            return {
                value: bankAccount && bankAccount.branchNumber,
                checkDigit: bankAccount && bankAccount.branchCheckDigit
            };
        };

        $ctrl.getAccountNumberModel = function () {
            var bankAccount = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.bankAccount;
            return {
                value: bankAccount && bankAccount.accountNumber,
                checkDigit: bankAccount && bankAccount.accountCheckDigit
            };
        };

        function updateBankNameLabel() {
            var bankAccount = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.bankAccount;
            var bankCode = bankAccount && bankAccount.bankCode;
            if (!bankCode) {
                $ctrl.bankNameLabel = '';
                return;
            }
            BankDataService.findBanks(bankCode, 0, 1).then(function (response) {
                if (response.data && response.data.length > 0) {
                    var bank = response.data[0];
                    $ctrl.bankNameLabel = bank.code + ' - ' + bank.name;
                } else {
                    $ctrl.bankNameLabel = bankCode;
                }
            });
        }

        $ctrl.getTransferIntervalLabel = function () {
            var transferInterval = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.transferInterval;
            if (!transferInterval) {
                return '';
            }
            return $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.' + transferInterval.toLowerCase());
        };

        $ctrl.getTransferDayLabel = function () {
            var transferInterval = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.transferInterval;
            var transferDay = $ctrl.pagarmeOptions && $ctrl.pagarmeOptions.transferDay;
            if (!transferDay) {
                return '';
            }
            if (transferInterval === pagarmeConstants.TRANSFER_INTERVAL_OPTIONS.WEEKLY && WEEKDAY_LABEL_KEYS[transferDay]) {
                return $translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.' + WEEKDAY_LABEL_KEYS[transferDay]);
            }
            return '' + transferDay;
        };

        $ctrl.isKycPending = function () {
            var recipientStatus = $ctrl.pagarMeAccount && $ctrl.pagarMeAccount.recipientStatus;
            var kycStatus = $ctrl.pagarMeAccount && $ctrl.pagarMeAccount.kycStatus;
            return recipientStatus === pagarmeConstants.RECIPIENT_STATUS.AFFILIATION && kycStatus === pagarmeConstants.KYC_STATUS.PARTIALLY_DENIED;
        };

        $ctrl.getKycLink = function () {
            return PagarMeV5Service.generateKycLink().then(function (response) {
                if (response.data && response.data.url) {
                    return { url: response.data.url, expiresAt: response.data.expiresAt };
                }
                return $q.reject(response);
            });
        };

        $ctrl.onKycLinkError = function (error) {
            if (error && error.data && error.data.headers && error.data.headers.statuskey) {
                toastr.error($translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.' + error.data.headers.statuskey));
            } else {
                toastr.error($translate.instant('settings.store.payments.tabs.pagarMe.recipientForm.pagarMeV5RecipientKycLinkError'));
            }
        };

        $ctrl.$onInit = function () {
            updateComputedRecipientFields();
        };

        $ctrl.$onChanges = function () {
            updateComputedRecipientFields();
        };

        function updateComputedRecipientFields() {
            $ctrl.recipientTypeLabel = $ctrl.getRecipientTypeLabel();
            $ctrl.recipientNameValue = $ctrl.getRecipientName();
            $ctrl.recipientDocumentValue = $ctrl.getRecipientDocument();
            $ctrl.recipientEmailValue = $ctrl.getRecipientEmail();
            $ctrl.holderTypeLabel = $ctrl.getHolderTypeLabel();
            $ctrl.bankAccountTypeLabel = $ctrl.getBankAccountTypeLabel();
            $ctrl.branchNumberModel = $ctrl.getBranchNumberModel();
            $ctrl.accountNumberModel = $ctrl.getAccountNumberModel();
            $ctrl.transferIntervalLabel = $ctrl.getTransferIntervalLabel();
            $ctrl.transferDayLabel = $ctrl.getTransferDayLabel();
            $ctrl.hasLoadError = $ctrl.computeHasLoadError();
            updateBankNameLabel();
        }
    }
})();
